export default "__VITE_ASSET__DZwu_Cvx__"